import { TI_RESIZABLE_ORIGINS } from '@utils/constants';

const MAX_HEIGHT = 20_000;
const DEADBAND_PX = 2;

// `context: 'iframe.resize'` is the canonical shape posted by the chart
// scaffold. The three `type` shapes are hand-written charts predating the
// standard, supported for the Phase 5 migration only — new charts must use the
// scaffold snippet.
export const readReportedHeight = (data: unknown): number | null => {
  if (typeof data !== 'object' || data === null) return null;
  const message = data as Record<string, unknown>;
  const isKnown =
    message.context === 'iframe.resize' ||
    message.type === 'resize' ||
    message.type === 'dcMapHeight' ||
    message.type === 'ti-card-height';
  if (!isKnown) return null;

  // Must be a number: a string like "400px" would otherwise be assigned
  // straight to style.height.
  const height = message.height;
  if (typeof height !== 'number' || !Number.isFinite(height)) return null;
  const rounded = Math.ceil(height);
  if (rounded <= 0 || rounded > MAX_HEIGHT) return null;
  return rounded;
};

export const isAllowedOrigin = (origin: string): boolean =>
  (TI_RESIZABLE_ORIGINS as readonly string[]).includes(origin);

// Stops oscillation with charts that measure document.body.scrollHeight, which
// grows once the parent applies a height.
export const shouldApplyHeight = (current: number, next: number): boolean =>
  Math.abs(next - current) >= DEADBAND_PX;
